import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { adminApi } from "@/lib/adminAuth";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

export default function AdminWhitelist() {
  const [list, setList] = useState([]);
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("admin");

  const load = () => api.get("/admin/whitelist", adminApi()).then(({ data }) => setList(data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!email) return;
    try {
      await api.post("/admin/whitelist", { email, role }, adminApi());
      toast.success("Eklendi");
      setEmail("");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Hata (super admin gerekli)"); }
  };

  const remove = async (em) => {
    if (!window.confirm(`${em} silinsin mi?`)) return;
    try {
      await api.delete(`/admin/whitelist/${em}`, adminApi());
      toast.success("Silindi");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
  };

  return (
    <div className="font-admin-body">
      <h1 className="font-admin-head text-3xl mb-2">Yönetici Whitelist</h1>
      <p className="text-sm text-white/60 mb-6">Sadece burada listelenen e-postalar yönetici olarak giriş yapabilir.</p>

      <div className="admin-card p-4 mb-4 flex gap-2 items-end">
        <div className="flex-1">
          <label className="text-xs text-white/50">E-posta</label>
          <input value={email} onChange={(e) => setEmail(e.target.value)} data-testid="wl-email-input" className="admin-input" placeholder="admin@mail.com" />
        </div>
        <div>
          <label className="text-xs text-white/50">Rol</label>
          <select value={role} onChange={(e) => setRole(e.target.value)} className="admin-input">
            <option value="admin">admin</option>
            <option value="super_admin">super_admin</option>
          </select>
        </div>
        <button onClick={add} data-testid="wl-add-btn" className="admin-btn flex items-center gap-1"><Plus className="w-4 h-4" /> Ekle</button>
      </div>

      <div className="admin-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-xs text-white/50 uppercase tracking-wider">
            <tr className="border-b border-[#27272A]">
              <th className="p-3">E-posta</th><th className="p-3">Rol</th><th className="p-3">Eklenme</th><th></th>
            </tr>
          </thead>
          <tbody>
            {list.map((w) => (
              <tr key={w.email} className="border-b border-[#18181B]">
                <td className="p-3">{w.email}</td>
                <td className="p-3"><span className={w.role === "super_admin" ? "text-[#F59E0B]" : "text-white/70"}>{w.role}</span></td>
                <td className="p-3 text-white/50 text-xs">{new Date(w.created_at).toLocaleDateString("tr-TR")}</td>
                <td className="p-3 text-right"><button onClick={() => remove(w.email)} className="admin-btn-ghost text-xs px-2 py-1 text-red-400"><Trash2 className="w-3 h-3" /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
